<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_ix"></a><a id="ack"></a><em>Acknowledgments</em></p>
<p class="noindent">Joe, Butch, Jimmie, Steve, Tony, Lloyd . . . Sharon, Adrienne, Janet . . . and all the more than three dozen men and women who shared their time, insight, and stories with me in the preparation of this volume.</p>
<p class="noindent-t">Casey Kittrell and the good folks at U.T. Press, including copyeditor Paul Spragens and book designer Lindsay Starr.</p>
<p class="noindent-t">Peter Blackstock and <em>No Depression</em>.</p>
<p class="noindent-t">Cameron and Peter and New West Records.</p>
<p class="noindent-t">The two Lances—Lance Cowan and Lance Webb.</p>
<p class="noindent-t"><a id="page_x"></a>Two books were most helpful for quotes and in researching this volume: Joe Carr and Alan Munde’s <em>Prairie Nights to Neon Lights</em> (Texas Tech University Press, 1995), a history of West Texas music; and Christopher Oglesby’s <em>Fire in the Water, Earth in the Air</em> (University of Texas Press, 2006), an oral history of West Texas musicians (along with Chris’s website, <a href="http://www.virtualubbock.com/" target="_blank">www.virtualubbock.com/</a>).</p>
<p class="noindent-t">Another valuable source for background and quotes was Amy Maner and George Sledge’s 2005 documentary film, <em>Lubbock Lights</em>.</p>
<p class="noindent-t">David Brown of KUTX-FM in Austin.</p>
<p class="noindent-t">Michael Ventura and the poets, philosophers, and seekers on 14th Street.</p>
<p class="noindent-t">And a tip of the Stetson to Miles Arceneaux, my favorite Famous Arthur.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292767317_07_ack.vue?cd49f9e8